import styled, { css } from 'styled-components';

import { mediaHover, rem } from 'approot/shared/style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { spacing8, spacing16 } from 'approot/shared/styles/spacing.style';
import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import {
  ButtonBaseProps,
  ButtonBaseStyled,
} from 'approot/shared/styles/buttons/base-button.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';

export const ComponentPlusLine = styled.div`
  height: ${rem(1)};
  background-color: ${grey5};
  width: 100%;
  position: absolute;
`;

type ComponentFieldWrapperProps = {
  $colours?: ColourItem | null;
  $showBackground?: boolean;
  $showBorder?: boolean;
};
export const ComponentFieldWrapper = styled.div<ComponentFieldWrapperProps>`
  border-radius: ${rem(borderRadius8)};

  ${({ $colours, $showBackground }) =>
    $colours &&
    $showBackground &&
    `
    background-color: ${$colours.colour1};
    padding: ${rem(spacing8)};
  `}

  ${({ $colours, $showBorder }) =>
    $colours &&
    $showBorder &&
    `
    border: 1px solid ${$colours.colour3};
    padding: ${rem(spacing8)};
  `}
`;

export const ComponentPlusToggle = styled.button<ButtonBaseProps>`
  ${ButtonBaseStyled}
  background: transparent;
  border: none;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${rem(24)};
  min-height: ${rem(24)};
  width: 100%;
  height: auto;
  padding: 0;
  z-index: 1;

  ${standardFocusState}

  svg {
    stroke: none;
  }
`;

type ComponentPlusWrapperProps = {
  $isAlwaysVisible?: boolean;
};
export const ComponentPlusWrapper = styled.div<ComponentPlusWrapperProps>`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: ${rem(24)};

  ${({ $isAlwaysVisible }) =>
    !$isAlwaysVisible &&
    css`
      ${mediaHover`
        ${ComponentPlusToggle}, ${ComponentPlusLine} {
          visibility: hidden;
        }
        &:hover {
          ${ComponentPlusToggle}, ${ComponentPlusLine}  {
            visibility: visible;
          }
        }
      `}
    `}
`;

export const ComponentActions = styled.div`
  ${baseFlexCss}
  gap: ${rem(spacing8)};
  position: absolute;
  right: ${rem(spacing16)};
  top: ${rem(spacing16)};
  z-index: 2;
`;
